import { useEffect, useState } from "react";
import { Divider, Group, TextInput, Checkbox, Button } from "@mantine/core";
import { Card, message, Flex, Spin } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";










const Complienceform = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [submitloading, setSubmitloading] = useState(false);
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState({
        Mobile_application_link: '',
        Web_portal_link: '',
        Privacy_policy_link: '',
        Terms_and_conditions_link: '',
        Refund_policy_link: '',
        Credentials_for_verification: '',
    })
    const [servicesOpteddetails, setServicesOpteddetails] = useState([
        {
            Use_case_of_this_service: '',
            Expected_daily_transaction: '',
            Expected_monthly_business_for_this_service: '',
            Min_ticket_size: '',
            Max_ticket_size: '',
            Average_ticket_size: '',
        }
    ])

    const handelChange_compliancedetails = (field, value) => {
        setCompliancedetails(prev => ({
            ...prev,
            [field]: value
        }))
    }
    const handelChange_servicesOpteddetails = (field, value, index) => {
        const updated = [...servicesOpteddetails];
        updated[index][field] = value;
        setServicesOpteddetails(updated);
    }
    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }

    const handelSubmit = async () => {
        const { Mobile_application_link, Web_portal_link, Privacy_policy_link, Terms_and_conditions_link, Refund_policy_link, Credentials_for_verification } = compliancedetails;

        if (!Privacy_policy_link || !Terms_and_conditions_link || !Refund_policy_link) {
            message.error('Please fill all the required fields in compliance details.');
            return;
        }
        const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/;
        if (!urlRegex.test(Privacy_policy_link)) {
            message.error('Please enter valid privacy policy link');
            return
        }
        if (!urlRegex.test(Terms_and_conditions_link)) {
            message.error('Please enter valid terms and conditions link');
            return
        }
        if (!urlRegex.test(Refund_policy_link)) {
            message.error('Please enter valid refund policy link');
            return
        }
        if (Mobile_application_link !== '' && !urlRegex.test(Mobile_application_link)) {
            message.error('Please enter valid mobile application link');
            return
        }
        if (Web_portal_link !== '' && !urlRegex.test(Web_portal_link)) {
            message.error('Please enter valid web portal link');
            return
        }
        const isInvalid = servicesOpteddetails.some(service =>
            !service.Use_case_of_this_service ||
            !service.Expected_daily_transaction ||
            !service.Expected_monthly_business_for_this_service ||
            !service.Min_ticket_size ||
            !service.Max_ticket_size ||
            !service.Average_ticket_size
        );

        if (isInvalid) {
            message.error('Please fill all the details for the selected service(s).');
            return;
        }

        setSubmitloading(true);
        const response = await fetch('https://api.boompay.in/submit-compliance-details', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            },
            body: JSON.stringify({
                Mobile_application_link, Web_portal_link, Privacy_policy_link, Terms_and_conditions_link, Refund_policy_link, Credentials_for_verification,
                Services_opted_in_details: servicesOpteddetails,
                Compnay_profile_schema_id: companyProfile?._id,
                Completed_step: 2, // Update the Completed_step to 2 after submitting compliance details and MAF
            })
        });
        const data = await response.json();
        if (response.status === 201) {
            message.success(data.message);
            getUserData(); // Fetch the updated user data after successful submission
            setCompliancedetails({
                Mobile_application_link: '',
                Web_portal_link: '',
                Privacy_policy_link: '',
                Terms_and_conditions_link: '',
                Refund_policy_link: '',
                Credentials_for_verification: '',
            })
            setServicesOpteddetails([
                {
                    Use_case_of_this_service: '',
                    Expected_daily_transaction: '',
                    Expected_monthly_business_for_this_service: '',
                    Min_ticket_size: '',
                    Max_ticket_size: '',
                    Average_ticket_size: '',
                }
            ])
            setSubmitloading(false);
        } else if (response.status === 401) {
            setSubmitloading(false);
            console.log('Unauthorized access. Please log in again.');
            message.error('Unauthorized access. Please log in again.');
        } else if (response.status === 404) {
            setSubmitloading(false);
            console.log('Company profile not found.');
            message.error('Company profile not found.');
        } else {
            setSubmitloading(false);
            console.log('An error occurred while submitting compliance details and MAF.');
            message.error('An error occurred while submitting compliance details and MAF.');
        }
    }

    const handleRectificationSubmit = async () => {
        const { Mobile_application_link, Web_portal_link, Privacy_policy_link, Terms_and_conditions_link, Refund_policy_link, Credentials_for_verification } = compliancedetails;
        if (!Privacy_policy_link || !Terms_and_conditions_link || !Refund_policy_link) {
            message.error('Please fill all the required fields in compliance details.');
            return;
        }
        const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/;
        if (!urlRegex.test(Privacy_policy_link)) {
            message.error('Please enter valid privacy policy link');
            return
        }
        if (!urlRegex.test(Terms_and_conditions_link)) {
            message.error('Please enter valid terms and conditions link');
            return
        }
        if (!urlRegex.test(Refund_policy_link)) {
            message.error('Please enter valid refund policy link');
            return
        }
        if (Mobile_application_link !== '' && !urlRegex.test(Mobile_application_link)) {
            message.error('Please enter valid mobile application link');
            return
        }
        if (Web_portal_link !== '' && !urlRegex.test(Web_portal_link)) {
            message.error('Please enter valid web portal link');
            return
        }
        const isInvalid = servicesOpteddetails.some(service =>
            !service.Use_case_of_this_service ||
            !service.Expected_daily_transaction ||
            !service.Expected_monthly_business_for_this_service ||
            !service.Min_ticket_size ||
            !service.Max_ticket_size ||
            !service.Average_ticket_size
        );

        if (isInvalid) {
            message.error('Please fill all the details for the selected service(s).');
            return;
        }
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/compliance-and-maf', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    Mobile_application_link, Web_portal_link, Privacy_policy_link, Terms_and_conditions_link, Refund_policy_link, Credentials_for_verification,
                    Services_opted_in_details: servicesOpteddetails,
                    Company_profile_schema_id: submissionDetails?.Company_profile_schema_id
                })
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setSubmitloading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }

    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
        }
    }, [user])
    useEffect(() => {
        if (companyProfile?.Services_opted) {
            const initial = companyProfile.Services_opted?.map((service) => ({
                Service_name: service, // ✅ important
                Use_case_of_this_service: '',
                Expected_daily_transaction: '',
                Expected_monthly_business_for_this_service: '',
                Min_ticket_size: '',
                Max_ticket_size: '',
                Average_ticket_size: '',
            }));

            setServicesOpteddetails(initial);
        }
    }, [companyProfile]);
    // const services = companyProfile?.Services_opted || [];
    useEffect(() => {
        const getUserData = async () => {
            setSubmitloading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            //console.log(data);
            if (response.status === 200) {
                const profile = data.RectificationDetails.Compliance_and_MAF_schema_id;
                // Compliance Details
                setCompliancedetails({
                    Mobile_application_link: profile.Mobile_application_link || "",
                    Web_portal_link: profile.Web_portal_link || "",
                    Privacy_policy_link: profile.Privacy_policy_link || "",
                    Terms_and_conditions_link: profile.Terms_and_conditions_link || "",
                    Refund_policy_link: profile.Refund_policy_link || "",
                    Credentials_for_verification: profile.Credentials_for_verification || "",
                });

                // Services Details
                setServicesOpteddetails(profile.Services_opted_in_details || []);
                setSubmitloading(false);
            } else if (response.status === 401) {
                setSubmitloading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setSubmitloading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setSubmitloading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={submitloading} size="large" description="Please wait...">
                    <Card title="Complience details & MAF" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Group>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Authorized person details" my="sm" variant="dashed" labelPosition="center" />

                        <Group>

                            <TextInput
                                label="Director name"
                                value={
                                    companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_name || ""
                                }
                                radius="xs"
                                size="md"
                                disabled
                            />

                            <TextInput
                                label="Director mobile number"
                                value={
                                    companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_mobile_number || ""
                                }
                                radius="xs"
                                size="md"
                                disabled
                            />

                            <TextInput
                                label="Director email id"
                                value={
                                    companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_email || ""
                                }
                                radius="xs"
                                size="md"
                                disabled
                            />

                            <TextInput
                                label="Director DIN number"
                                value={
                                    companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_DIN_number || ""
                                }
                                radius="xs"
                                size="md"
                                disabled
                            />

                            <TextInput
                                label="Date of appointment"
                                value={
                                    companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Date_of_appointment?.split("T")[0] || ""
                                }
                                radius="xs"
                                size="md"
                                disabled
                            />

                            <TextInput
                                label="Share %"
                                value={
                                    companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Share_perecentage || ""
                                }
                                radius="xs"
                                size="md"
                                disabled
                            />
                        </Group>
                        <Divider label="Compliance details" my="sm" variant="dashed" labelPosition="center" />
                        <Group>
                            <TextInput
                                label="Mobile Application link (if any)"
                                name="Mobile_application_link"
                                value={compliancedetails.Mobile_application_link}
                                onChange={(e) => handelChange_compliancedetails("Mobile_application_link", e.target.value)}

                                radius="xs"
                                size="md"
                            />

                            <TextInput
                                label="Web Portal link (if any)"
                                name="Web_portal_link"
                                value={compliancedetails.Web_portal_link}
                                onChange={(e) => handelChange_compliancedetails("Web_portal_link", e.target.value)}

                                radius="xs"
                                size="md"
                            />

                            <TextInput
                                label="Privacy policy link"
                                name="Privacy_policy_link"
                                value={compliancedetails.Privacy_policy_link}
                                onChange={(e) => handelChange_compliancedetails("Privacy_policy_link", e.target.value)}
                                required

                                radius="xs"
                                size="md"
                            />

                            <TextInput
                                label="Terms and conditions link"
                                name="Terms_and_conditions_link"
                                value={compliancedetails.Terms_and_conditions_link}
                                onChange={(e) => handelChange_compliancedetails("Terms_and_conditions_link", e.target.value)}
                                required

                                radius="xs"
                                size="md"
                            />

                            <TextInput
                                label="Refund policy link"
                                name="Mobile_application_link"
                                value={compliancedetails.Refund_policy_link}
                                onChange={(e) => handelChange_compliancedetails("Refund_policy_link", e.target.value)}
                                required

                                radius="xs"
                                size="md"
                            />

                            <TextInput
                                label="Credentials for verification (if any)"
                                name="Credentials_for_verification"
                                value={compliancedetails.Credentials_for_verification}
                                onChange={(e) => handelChange_compliancedetails("Credentials_for_verification", e.target.value)}

                                radius="xs"
                                size="md"
                            />
                        </Group>
                        <Divider label="Selected services in detail" my="sm" variant="dashed" labelPosition="center" />
                        <Group mt="lg">
                            {servicesOpteddetails.map((service, index) => (
                                <Card key={index} withBorder p="sm" mt="sm">

                                    <Checkbox label={service.Service_name} checked disabled />

                                    <TextInput
                                        size="xs"
                                        label="Use case of this service"
                                        required

                                        value={service.Use_case_of_this_service}
                                        onChange={(e) =>
                                            handelChange_servicesOpteddetails(
                                                'Use_case_of_this_service',
                                                e.target.value,
                                                index
                                            )
                                        }
                                    />

                                    <TextInput
                                        size="xs"
                                        label="Expected daily transaction"
                                        required

                                        value={service.Expected_daily_transaction}
                                        onChange={(e) =>
                                            handelChange_servicesOpteddetails(
                                                'Expected_daily_transaction',
                                                e.target.value,
                                                index
                                            )
                                        }
                                    />

                                    <TextInput
                                        size="xs"
                                        label="Expected monthly business"
                                        required

                                        value={service.Expected_monthly_business_for_this_service}
                                        onChange={(e) =>
                                            handelChange_servicesOpteddetails(
                                                'Expected_monthly_business_for_this_service',
                                                e.target.value,
                                                index
                                            )
                                        }
                                    />

                                    <TextInput
                                        size="xs"
                                        label="Min ticket size"
                                        required

                                        value={service.Min_ticket_size}
                                        onChange={(e) =>
                                            handelChange_servicesOpteddetails('Min_ticket_size', e.target.value, index)
                                        }
                                    />

                                    <TextInput
                                        size="xs"
                                        label="Avg ticket size"
                                        required

                                        value={service.Average_ticket_size}
                                        onChange={(e) =>
                                            handelChange_servicesOpteddetails('Average_ticket_size', e.target.value, index)
                                        }
                                    />

                                    <TextInput
                                        size="xs"
                                        label="Max ticket size"
                                        required

                                        value={service.Max_ticket_size}
                                        onChange={(e) =>
                                            handelChange_servicesOpteddetails('Max_ticket_size', e.target.value, index)
                                        }
                                    />
                                </Card>
                            ))}
                        </Group>
                        {/* <Group mt="lg">
                            {services.map((service, index) => (
                                <Card key={index} withBorder p="sm" mt="sm">
                                    <Checkbox label={service} checked={service} disabled />

                                    <TextInput size="xs" label="Use case of this service" required variant="filled" name="Use_case_of_this_service" value={servicesOpteddetails.Use_case_of_this_service} onChange={(e) => handelChange_servicesOpteddetails('Use_case_of_this_service', e.target.value, index)} />
                                    <TextInput size="xs" label="Expected daily transaction" required variant="filled" name="Expected_daily_transaction" value={servicesOpteddetails.Expected_daily_transaction} onChange={(e) => handelChange_servicesOpteddetails('Expected_daily_transaction', e.target.value, index)} />
                                    <TextInput size="xs" label="Expected monthly business" required variant="filled" name="Expected_monthly_business_for_this_service" value={servicesOpteddetails.Expected_monthly_business_for_this_service} onChange={(e) => handelChange_servicesOpteddetails('Expected_monthly_business_for_this_service', e.target.value, index)} />
                                    <TextInput size="xs" label="Min ticket size" required variant="filled" name="Min_ticket_size" value={servicesOpteddetails.Min_ticket_size} onChange={(e) => handelChange_servicesOpteddetails('Min_ticket_size', e.target.value, index)} />
                                    <TextInput size="xs" label="Avg ticket size" required variant="filled" name="Average_ticket_size" value={servicesOpteddetails.Average_ticket_size} onChange={(e) => handelChange_servicesOpteddetails('Average_ticket_size', e.target.value, index)} />
                                    <TextInput size="xs" label="Max ticket size" required variant="filled" name="Max_ticket_size" value={servicesOpteddetails.Max_ticket_size} onChange={(e) => handelChange_servicesOpteddetails('Max_ticket_size', e.target.value, index)} />
                                </Card>
                            ))}
                        </Group> */}


                        <Group justify="end">
                            {/* <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handelSubmit} loading={submitloading}>Save changes</Button> */}
                            <Button
                                mt={'md'}
                                size="lg"
                                color="lime"
                                variant="light"
                                loading={submitloading}
                                onClick={
                                    rectification
                                        ? handleRectificationSubmit
                                        : handelSubmit
                                }
                            >
                                {
                                    rectification
                                        ? "Submit Rectification"
                                        : "Save Changes"
                                }
                            </Button>
                        </Group>

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Complienceform